import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let sessionId = null;

// Generate or retrieve session ID
const getSessionId = () => {
  if (sessionId) return sessionId;
  
  sessionId = localStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

// Detect device type
const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/mobile|android|iphone|ipad|tablet/.test(userAgent)) {
    return 'mobile';
  }
  return 'desktop';
};

// Track analytics event
export const trackEvent = async (eventType, data = {}) => {
  try {
    await axios.post(`${API}/analytics/track`, {
      event_type: eventType,
      page_url: window.location.pathname,
      session_id: getSessionId(),
      device_type: getDeviceType(),
      ...data
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

// Track page view
export const trackPageView = (pagePath) => {
  trackEvent('page_view', { page_url: pagePath });
};

// Track CTA click
export const trackCTAClick = (ctaType) => {
  trackEvent('cta_click', { cta_type: ctaType });
};

// Track form submission
export const trackFormSubmit = (formType) => {
  trackEvent('form_submit', { cta_type: formType });
};
